module.exports = __webpack_public_path__ + "img/SP5.16b42e91.png";